import React from "react";
import { Modal } from "react-bootstrap";
import "react-calendar/dist/Calendar.css";
import Moment from "moment";
import { formatPhoneNumberString, formatBooleanAsString, ConvertEmptyToNA } from "../Util/Utils";
import "../style/DetailsModals.css";

const UpdateRequestDetailsModal = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        {props.request && (
          <Modal.Title id="contained-modal-title-vcenter">
            Change User Request - {props.request.UserFullName}
          </Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body>
        {props.request && (
          <div className="row justify-content-center">
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>User Full Name</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestFullName"
                  value={props.request.UserFullName}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>User Job Title</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestJobTitle"
                  value={props.request.JobTitle}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg ">
                <strong>Requested Date</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestRequestedDate"
                  value={Moment(props.request.CreatedDate).format("MMMM Do YYYY, h:mma")}
                  disabled={true}
                />
              </div>
              <div className="col-lg ">
                <strong>Requested By</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestRequestedBy"
                  value={props.request.RequestedBy}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Phone Number</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestEmailAccessDuration"
                  value={formatPhoneNumberString(
                    props.request.PhoneNumber1,
                    props.request.PhoneNumber1Ext,
                    props.request.PhoneNumber1Type
                  )}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Secondary Phone Number</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestEmailRecipient"
                  value={formatPhoneNumberString(
                    props.request.PhoneNumber2,
                    props.request.PhoneNumber2Ext,
                    props.request.PhoneNumber2Type
                  )}
                  disabled={true}
                />
              </div>
            </div>
            {props.request.OtherDistros && (
              <div className="row justify-content-center my-1">
                <div className="col-md ">
                  <strong>Email Distros</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="updateUserRequestEmailDistros"
                    value={ConvertEmptyToNA(props.request.OtherDistros.replace(", undefined", ""))}
                    disabled={true}
                  />
                </div>
              </div>
            )}

            <div className="row justify-content-center my-1">
              <div className="col-md">
                <strong>Who is being replaced?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestIsUnplanned"
                  value={ConvertEmptyToNA(props.request.PersonReplacing)}
                  disabled={true}
                />
              </div>
              <div className="col-md">
                <strong>Who should be notified?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={ConvertEmptyToNA(props.request.Notify)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Business Central Security Role</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestIsUnplanned"
                  value={ConvertEmptyToNA(props.request.BusinessCentralSecurityRole)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Contract And Financial Details Access</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={ConvertEmptyToNA(props.request.ContractAndFinancialDetailsAccess)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-md ">
                <strong>Effective Date</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserEffectiveDate"
                  value={Moment(props.request.EffectiveDate).format("MMMM Do YYYY, h:mma")}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Supply Sales Access</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyFranchisee"
                  value={ConvertEmptyToNA(props.request.SupplySalesAccess)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-sm ">
                <strong>Avalara?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestIsUnplanned"
                  value={formatBooleanAsString(props.request.Avalara)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-sm">
                <strong>Vena?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.Vena)}
                  disabled={true}
                />
              </div>
              <div className="col-sm ">
                <strong>Acrobat Pro?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.AcrobatPro)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Monitors?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.Monitors)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>City Wide You Admin?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.CityWideYouAdmin)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Training Environments?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyFranchisee"
                  value={formatBooleanAsString(props.request.TrainingEnvironments)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Desk Phone?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.DeskPhone)}
                  disabled={true}
                />
              </div>
            </div>
            <div className="row justify-content-center my-1">
              <div className="col-lg">
                <strong>Headset?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.Headset)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Zendesk Agent?</strong>
                <input
                  type="text"
                  className={`text-input w-100`}
                  name="updateUserRequestNotifyOther"
                  value={formatBooleanAsString(props.request.HubStaff)}
                  disabled={true}
                />
              </div>
              <div className="col-lg">
                <strong>Max Agent?</strong>
                <input
                  type="text"
                  className={`text-input  w-100`}
                  name="updateUserRequestIsUnplanned"
                  value={formatBooleanAsString(props.request.MaxAgent)}
                  disabled={true}
                />
              </div>
            </div>
            {props.mode === "completed" && (
              <div className="row justify-content-center my-1">
                <div className="col-lg">
                  <strong>Completed Date</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="updateUserRequestRequestedDate"
                    value={Moment(props.request.CompletedDate).format("MMMM Do YYYY, h:mma")}
                    disabled={true}
                  />
                </div>
                <div className="col-lg ">
                  <strong>Completed By</strong>
                  <input
                    type="text"
                    className={`text-input w-100`}
                    name="updateUserRequestRequestedBy"
                    value={props.request.CompletedBy}
                    disabled={true}
                  />
                </div>
              </div>
            )}
            <div className="row justify-content-left">
              <div className="col-md-3 text-left my-1" style={{ width: "100%" }}>
                <strong>Special Instructions:</strong>
                <textarea
                  className="text-input "
                  rows={7}
                  style={{ width: "100%" }}
                  disabled
                  value={props.request.SpecialInstructions}
                ></textarea>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default UpdateRequestDetailsModal;
